import { loadTheme } from './loadTheme';
import { monitorSystemThemeChanges } from './monitorSystemThemeChanges';
import { setCustomPalette } from '../mutators/setCustomPalette';
import { ThemeMode } from '../schema/ThemeMode';

/**
 * Load the theme and set the css variables on the document
 */
export const loadInitialTheme = (
    themeMode: ThemeMode,
    customPalette?: Record<string, string>
): void => {
    setCustomPalette(customPalette);
    loadTheme(themeMode);
    monitorSystemThemeChanges();
};
